import * as jwtDecode from 'jsonwebtoken'

export const maxSessionTime = (time, jwt, QUEUE_URL, sessionId) => {
  const timeInMs = Number(time) * 1000 * 60;

  if (Number(time) === 0 || time === '' || !time) return;

  if (isNaN(timeInMs) === false) {
    var myCss = `
      #maxSessionTime {
        opacity: 0.8;
        position: fixed;
        z-index: 1000000;
        bottom: 40px;
        right: 40px;
        text-align: center;
        background-color: #000;
        color: #fff;
        padding: 10px;
        font-size: 12px;
        font-family: sans-serif;
        border-radius: 4px;
      }
      #maxSessionTime b {
        font-size: 15px;
        padding: 5px;
        margin: 0;
        display: block;
      }
    `;

    // get jwt issue time
    const jwtDecoded = jwtDecode.decode(jwt)

    var style = document.createElement("STYLE");
    style.innerText = myCss;
    const div = document.createElement("div");
    div.id = "maxSessionTime";

    document.body.appendChild(style);
    document.body.appendChild(div);

    const runTimer = () => {
      const date = new Date((jwtDecoded.iat * 1000));
      const now = new Date();

      const diff =  timeInMs - (now.getTime() - date.getTime());

      const minutes = Math.floor(diff / 1000 / 60);
      const seconds = Math.floor(diff / 1000) % 60;

      if (diff < 0) {
        window.localStorage.removeItem(`${sessionId}-access-token`);
        window.location.href = `${QUEUE_URL}/${sessionId}?clearSession=true&?url=${encodeURIComponent(window.location.href)}`;
      }

      div.innerHTML = `Você tem <b>${minutes}min ${seconds}s</b> para concluir sua compra.`;

      setTimeout(runTimer, 1000);
    }

    // if (!jwtDecoded.isBypass) {
      runTimer();
    // }
  }
}
